module.exports = __webpack_public_path__ + "static/media/loader.9064981b.svg";